import { render } from "./winbar.vue?vue&type=template&id=099c3e40"
import script from "./winbar.vue?vue&type=script&lang=js"
export * from "./winbar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__